import {useNavigate} from 'react-router-dom';
import {
    FlexiCancelButton
} from "@flexinet/ui-components";

export const useEditPageTools = () => {

    const navigate = useNavigate();

    const tools = [];

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(`/deployment-account-groups`)}/>);

    return {
        tools,
    };
};
